module.exports = __webpack_public_path__ + "7fdcf4cb2e3a9f56c4bbcc2a80b11200.svg";